import React from "react";

const SvgComponent = props => (
  <svg width={26.568} height={28.475} viewBox="0 0 26.568 28.475" {...props}>
    <path
      d="M.07 12.568C-.703 20.506 5.035 27.59 12.969 28.4c4.913.502 9.47-1.555 12.474-5.022 2.785-3.197-.33-3.181-1.471-3.299C12.232 18.537 10.314 6.86 12.146 2.131c.582-2.273-.621-2.284-1.576-2.009 0 0-9.601 2.611-10.5 12.446zm13.239 12.5C7.215 24.445 2.781 19 3.402 12.908c.354-3.454 2.285-6.474 4.979-8.242-1.326 7.823 4.613 16.961 13.105 17.854-2.161 1.65-5.258 2.845-8.177 2.548z"
      fill="#83a5b3"
    />
  </svg>
);

export default __webpack_public_path__ + "static/media/01n.bd386a65.svg";
export { SvgComponent as ReactComponent };



// WEBPACK FOOTER //
// ./src/assets/weather-icons/01n.svg